export const environment = {
  production: true,
  awsAccessKeyId: 'AKIAZRKT2LU7VS3XORCB',
  awsSecretAccessKey: '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'
};